const DATA_API_HOST = process.env.DATA_API_HOST;

function getHostUrlForIntegrations() {
    return `${DATA_API_HOST}`;
}

export default getHostUrlForIntegrations;
